export const RecommendationWriteRight = "WEB_MODULE_EXEMPTION_APPLICATION_RECOMMENDATION_WRITE";
export const DecisionWriteRight = "WEB_MODULE_EXEMPTION_APPLICATION_DECISION_WRITE";

export const Rights = [
    RecommendationWriteRight,
    DecisionWriteRight
]
